import React from 'react';
import { Row, Col, Typography, Card } from 'antd';
import {
  SafetyCertificateOutlined,
  TrophyOutlined,
  DollarOutlined,
  CustomerServiceOutlined,
  CheckCircleOutlined,
  ToolOutlined,
} from '@ant-design/icons';
import { getThemeColors } from '../../config/shop.config';

const { Title, Text } = Typography;

const TrustBadgesSection: React.FC = () => {
  const themeColors = getThemeColors();

  const badges = [
    {
      icon: <SafetyCertificateOutlined style={{ fontSize: '42px', color: themeColors.primary }} />,
      title: 'Certified Technicians',
      description: 'Factory-trained and ASE certified experts',
      color: `${themeColors.primary}15`,
    },
    {
      icon: <TrophyOutlined style={{ fontSize: '42px', color: '#fbbf24' }} />,
      title: 'Award-Winning Service',
      description: 'Trusted by thousands of satisfied customers',
      color: '#fef3c7',
    },
    {
      icon: <DollarOutlined style={{ fontSize: '42px', color: '#10b981' }} />,
      title: 'Price Match Guarantee',
      description: 'We beat or match any quote',
      color: '#d1fae5',
    },
    {
      icon: <CheckCircleOutlined style={{ fontSize: '42px', color: '#3b82f6' }} />,
      title: 'Quality Guarantee',
      description: 'All work backed by our warranty',
      color: '#dbeafe',
    },
    {
      icon: <CustomerServiceOutlined style={{ fontSize: '42px', color: '#8b5cf6' }} />,
      title: '24/7 Support',
      description: 'Always here when you need us',
      color: '#ede9fe',
    },
    {
      icon: <ToolOutlined style={{ fontSize: '42px', color: '#f59e0b' }} />,
      title: 'Latest Equipment',
      description: 'State-of-the-art diagnostic tools',
      color: '#fef3c7',
    },
  ];

  return (
    <div style={{ padding: '60px 20px', backgroundColor: '#ffffff' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        {/* Section Header */}
        <div style={{ textAlign: 'center', marginBottom: '48px' }}>
          <Title level={3} style={{ color: '#111827', marginBottom: '12px' }}>
            Why Choose Us
          </Title>
          <Text style={{ fontSize: '16px', color: '#6b7280' }}>
            Your trusted automotive service partner
          </Text>
        </div>

        {/* Badges Grid */}
        <Row gutter={[24, 24]}>
          {badges.map((badge, index) => (
            <Col xs={12} sm={8} md={8} lg={4} key={index}>
              <Card
                variant="borderless"
                style={{
                  textAlign: 'center',
                  backgroundColor: badge.color,
                  borderRadius: '12px',
                  height: '100%',
                  transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                }}
                bodyStyle={{ padding: '20px 12px' }}
                hoverable
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-4px)';
                  e.currentTarget.style.boxShadow = '0 8px 16px rgba(0,0,0,0.1)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = 'none';
                }}
              >
                <div style={{ marginBottom: '12px' }}>{badge.icon}</div>
                <Text
                  strong
                  style={{
                    display: 'block',
                    fontSize: '14px',
                    marginBottom: '6px',
                    color: '#111827',
                  }}
                >
                  {badge.title}
                </Text>
                <Text
                  style={{
                    fontSize: '12px',
                    color: '#6b7280',
                    display: 'block',
                    lineHeight: '1.4',
                  }}
                >
                  {badge.description}
                </Text>
              </Card>
            </Col>
          ))}
        </Row>

        {/* Bottom CTA */}
        <div
          style={{
            marginTop: '48px',
            textAlign: 'center',
            padding: '40px',
            background: `linear-gradient(135deg, ${themeColors.primary} 0%, ${themeColors.accent} 100%)`,
            borderRadius: '16px',
            color: 'white',
          }}
        >
          <Title level={3} style={{ color: 'white', marginBottom: '12px' }}>
            Ready to Experience the Difference?
          </Title>
          <Text style={{ fontSize: '18px', color: 'rgba(255, 255, 255, 0.95)' }}>
            Book your service appointment today and see why we're the trusted choice for automotive excellence
          </Text>
        </div>
      </div>
    </div>
  );
};

export default TrustBadgesSection;
